module.exports = __webpack_public_path__ + "img/default.f33a7a04.png";